import { Check, ShoppingBasket } from 'components/icons'
import { Button, Modal, Link } from 'components/ui'
import type { FC } from 'react'
import { useEffect, useState, useCallback } from 'react'
import timeago from 'helpers/timeago'
import cn from 'classnames'
import { useCart } from 'hooks/use-cart'
import { ShippingService } from 'modules/cart/services'
import { parseCookies } from 'nookies'
import { useMercadinho } from 'hooks/use-mercadinho'
import { useRouter } from 'next/router'
import { isPedidoFacilSession } from 'modules/pedido-facil/utils/pedido-facil-session'
import type { ButtonAddToCartProps } from '.'
import s from './button-add-to-cart.module.css'

const ButtonAddToCart: FC<ButtonAddToCartProps> = ({
  inCart = null,
  label = 'Comprar',
  onClick,
  className,
  product,
  quantity,
}) => {
  const { setPopup, zipCode } = useCart()
  const [loading, setLoading] = useState<boolean>(false)
  const [click, setClick] = useState<boolean>(false)
  const [entrega, setEntrega] = useState<boolean | null>(null)
  const [modal, setModal] = useState<boolean>(false)
  const [show, setShow] = useState<boolean>(false)
  const [toSubscription, setToSubscription] = useState<boolean>(false)
  const cookies = parseCookies() // todo
  const storedZipCode = (cookies.zipcode as never) || ''

  const { isMercadinho } = useMercadinho()
  const router = useRouter()
  const isPedidoFacil = isPedidoFacilSession(router.pathname)
  const calc = useCallback(
    async (subscription: boolean = false) => {
      if (click && isMercadinho) {
        onClick(toSubscription)
        setPopup(false)
        setClick(false)
        setLoading(false)
        return
      }

      if (click) {
        const shipmentService = new ShippingService()

        try {
          const { data } = await shipmentService.calculateProductFreightV2(product, zipCode, quantity)
          const porra: any[] = []

          const firstProductId = Object.keys(data[Object.keys(data)[0]].products)[0];
          const method = data[Object.keys(data)[0]];
          const firstProduct = method?.products[firstProductId];

          // if (data?.fazendinhalog && data?.fazendinhalog?.shipping && data?.fazendinhalog?.shipping.length > 0) {
          //   const hasShipping = data?.fazendinhalog?.shipping
          //   if (hasShipping) {
          //     // eslint-disable-next-line array-callback-return
          //     hasShipping.map(() => {
          //       porra.push({
          //         success: data?.fazendinhalog?.success,
          //       })
          //     })
          //   }
          // }

          const deliveryWays = Object.keys(firstProduct.delivery_ways);

          if(deliveryWays.includes('fazendinhalog')) {
            if(typeof firstProduct.delivery_ways['fazendinhalog'] != 'string') {
              porra.push({
                success: firstProduct?.delivery_ways?.fazendinhalog?.success,
              })
            } else {
              porra.push({
                success: false,
              })
            }
          }

          // const fazendinhaTechLog = data['fazendinha-tech-log'] || {}

          // if (fazendinhaTechLog && fazendinhaTechLog.shipping && fazendinhaTechLog.shipping.length > 0) {
          //   const hasShipping = fazendinhaTechLog.shipping
          //   if (hasShipping) {
          //     // eslint-disable-next-line array-callback-return
          //     hasShipping.map(() => {
          //       porra.push({
          //         success: fazendinhaTechLog.success,
          //       })
          //     })
          //   }
          // }

          if(deliveryWays.includes('fazendinha-tech-log')) {
            if(typeof firstProduct.delivery_ways['fazendinha-tech-log'] != 'string') {
              porra.push({
                success: firstProduct?.delivery_ways['fazendinha-tech-log']?.success,
              })
            } else {
              porra.push({
                success: false,
              })
            }
          }

          // const fazendinhaTech = data['fazendinha-tech'] || {}

          // if (fazendinhaTech && fazendinhaTech.shipping && fazendinhaTech.shipping.length > 0) {
          //   const hasShipping = fazendinhaTech.shipping
          //   if (hasShipping) {
          //     // eslint-disable-next-line array-callback-return
          //     hasShipping.map(() => {
          //       porra.push({
          //         success: fazendinhaTech.success,
          //       })
          //     })
          //   }
          // }

          if(deliveryWays.includes('fazendinha-tech')) {
            if(typeof firstProduct.delivery_ways['fazendinha-tech'] != 'string') {
              porra.push({
                success: firstProduct?.delivery_ways['fazendinha-tech']?.success,
              })
            } else {
              porra.push({
                success: false,
              })
            }
          }

          // const retiradaLocal = data.retirada_local || {}

          // if (retiradaLocal && retiradaLocal.farmers) {
          //   porra.push({
          //     success: true,
          //   })
          // }

          if(deliveryWays.includes('retirada-local')) {
            if(typeof firstProduct.delivery_ways['retirada-local'] != 'string') {
              porra.push({
                success: true
              })
            } else {
              porra.push({
                success: false,
              })
            }
          }

          if(deliveryWays.includes('jadlog')) {
            if(typeof firstProduct.delivery_ways['jadlog'] != 'string') {
              porra.push({
                success: true
              })
            } else {
              porra.push({
                success: false,
              })
            }
          }

          if (porra.length > 0) {
            let block = true
            porra.forEach((p) => {
              if (p.success) {
                block = false
              }
            })
            setEntrega(block)

            if (block) {
              setModal(true)
            } else {
              onClick(toSubscription)
            }
          } else {
            setEntrega(true)
          }
        } catch (e) {
          setModal(true)
        } finally {
          setPopup(false)
          setClick(false)
          setLoading(false)
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [zipCode, click],
  )

  useEffect(() => {
    if (isMercadinho && click) {
      calc(false)
      return
    }
    if (zipCode !== null && zipCode !== '' && zipCode !== undefined && entrega === null && click) {
      calc(false)
    }
  }, [zipCode, entrega, calc, click])

  const handleClick = async (subscription: boolean = false) => {
    setToSubscription(subscription)
    setShow(false)
    setClick(true)
    setLoading(true)

    if (!isMercadinho && (zipCode === null || zipCode === '' || zipCode === undefined || entrega === true)) {
      setPopup(true)
      return
    }

    return calc(subscription)
  }

  return (
    <>
      <Modal open={modal} onClose={() => setModal(false)} className={s.modal_delivery}>
        <img
          src="/assets/images/cidade.png"
          alt="Este produtor não atende o seu CEP. Confira quais produtos estão disponíveis na sua localidade ou troque o CEP.."
          style={{ height: '100%', margin: '0px auto 20px auto' }}
        />
        <div className={s.sua_regiao}>
          <div className={s.available_products}>
            Confira{' '}
            <Link href={`/produtos?zipcode=${storedZipCode}`}>
              {' '}
              <strong>aqui</strong>
            </Link>{' '}
            quais produtos estão disponíveis na sua localidade ou troque o seu CEP.
          </div>
        </div>
        <div className={s.sua_regiao__button}>
          <Button
            variant="ghost"
            onClick={() => {
              setModal(false)
              setPopup(true)
            }}
          >
            Trocar CEP
          </Button>
        </div>
        <div className={s.sua_regiao}>
          <p>Este produto não está disponível para o seu CEP.</p>
        </div>
      </Modal>

      {product.assinatura.toString() == '1' && !isPedidoFacil && (
        <div className='relative'>
          <div>
            <Button
              type="button"
              className={cn(s.root, className)}
              id="menu-button"
              aria-expanded="false"
              aria-haspopup="false"
              onClick={() => setShow(!show)}
            >
              Comprar
              <svg
                width="23"
                height="23"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="false"
              >
                {!inCart && (
                  <path d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" />
                )}
                {inCart && <Check />}
              </svg>
            </Button>
          </div>

          <div className={show ? 'absolute right-0' : 'hidden'}>
            <div
              className={s.options}
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabIndex={-1}
            >
              <div className="py-1" role="none">
                <a
                  onClick={() => handleClick(true)}
                  className={s.option}
                  role="menuitem"
                  tabIndex={-1}
                  id="menu-item-0"
                >
                  Assinar
                </a>
                <a
                  onClick={() => handleClick(false)}
                  className={s.option}
                  role="menuitem"
                  tabIndex={-1}
                  id="menu-item-1"
                >
                  Comprar
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {(!product.assinatura || isPedidoFacil) && (
        <Button
          variant="primary"
          onClick={() => handleClick(false)}
          title={inCart ? `Adicionado ao carrinho ${timeago(inCart)}` : label}
          loading={loading}
          className={cn(s.root, className)}
        >
          {!inCart ? <ShoppingBasket /> : <Check />}
          <span>{label}</span>
        </Button>
      )}
    </>
  )
}

export default ButtonAddToCart
